import { applyMiddleware, combineReducers, createStore } from "redux";
import type { Dispatch, UnknownAction } from "redux";
import { thunk } from "redux-thunk";
import type { ThunkDispatch } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import { reducer as alertReducer } from "@/store/alertReducer";
import { reducer as cacheReducer, type CacheState } from "@/store/cacheReducer";
import { reducer as pageLoadingReducer } from "@/store/pageLoadingReducer";
import { reducer as cartReducer } from "@/store/cartReducer";
import { reducer as appReadyReducer } from "@/store/appReadyReducer";
import { cacheMiddleware } from "@/store/middleware/cacheMiddleware";
import { restoreCacheFromStorage } from "@/utils/cacheManager";

export type RootState = ReturnType<typeof reducers>;
export type AppDispatch = Dispatch<UnknownAction> &
  ThunkDispatch<RootState, undefined, UnknownAction>;

const reducers = combineReducers({
  alertMessages: alertReducer,
  cache: cacheReducer,
  pageLoading: pageLoadingReducer,
  cart: cartReducer,
  appReady: appReadyReducer,
});

// store 初始化時恢復快取
const preloadedState: Partial<RootState> = {
  cache: restoreCacheFromStorage() as CacheState,
};

const store = createStore(
  reducers,
  preloadedState,
  composeWithDevTools(applyMiddleware(thunk, cacheMiddleware)),
);

export default store;
